<template>
  <div v-if="!isLoading">
    <DxDataGrid
        :data-source="dataSource"
        :show-borders="true"
        key-expr="id"
        height="500px"
        :column-auto-width="true"
        :allow-column-reordering="true"
    >

      <DxSearchPanel
          :visible="true"
          :width="240"
          placeholder="Search..."
      />
      <DxEditing
          :allow-updating="true"
          :allow-adding="false"
          :allow-deleting="false"
          :select-text-on-edit-start="true"
          start-edit-action="dblClick"
          :use-icons="true"
          mode="batch"
      />
      <DxPaging :enabled="false"/>

      <DxColumn data-field="id" caption="ID" :allow-editing="false"/>
      <DxColumn data-field="name" caption="Channel Name"/>
      <DxColumn data-field="subchannel" caption="Sub Channel Name"/>
     

      <DxScrolling
          column-rendering-mode="virtual"
          mode="infinite"/>
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxLookup, DxScrolling, DxSearchPanel
} from 'devextreme-vue/data-grid';
import DxSelectBox from 'devextreme-vue/select-box';
import DxCheckBox from 'devextreme-vue/check-box';
import {createStore} from "devextreme-aspnet-data-nojquery";
import {DxButton} from "devextreme-vue/button";

export default {
  name: "Locations",
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxLookup,
    DxCheckBox,
    DxSelectBox,
    DxScrolling,
    DxButton,
    DxSearchPanel
  },

  data() {
    return {
      dataSource: null,
      isLoading: false
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData() {

      this.isLoading = true;
      const url = this.getApiUrl();
      const clientId = this.getClientId();

      this.dataSource = createStore({
        loadUrl: `${url}/api/slims-utilities/channels`,
        updateUrl: `${url}/api/slims-utilities/channels/update?clientId=${clientId}`,
        key: 'id',
        onBeforeSend: (method, ajaxOptions) => {
          const token = this.getTokenSilently();
          ajaxOptions.headers = {
            Authorization: `Bearer ${token}`
          }
          ajaxOptions.data = {
            ...ajaxOptions.data,
            clientId: clientId
          }
        }
      });
      
      this.isLoading = false;
    }
  }
}
</script>

<style scoped>
.data-grid {
  height: 250px
}
</style>